module.exports = __webpack_public_path__ + "static/media/creature-palm.96c88ff8.svg";